import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const BounceEmaTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const updateTactic = (field, newValue) => {
      updatePlugins(
        'setup',
        { [field]: newValue },
        'BOUNCE_EMA',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.setupDetails['BOUNCE_EMA']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['BOUNCE_EMA'].candleDuration
                    }
                    updateValue={(newValue) =>
                      updateTactic('candleDuration', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Period Length
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={
                      tradePlan.setupDetails['BOUNCE_EMA'].periodLength
                    }
                    updateValue={(newValue) =>
                      updateTactic('periodLength', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor={colors.black}
                  />
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {'Time Unit(read-only)'}
                  </Body3>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {tradePlan.setupDetails['BOUNCE_EMA'].timeUnit}
                  </Body3>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

BounceEmaTacticPanel.tabsRole = 'TabPanel';
